<script lang="ts" setup>
// import text1 from '@/assets/images/fv_text1.svg'
// import text2 from '@/assets/images/fv_text2.svg'
// import text3 from '@/assets/images/fv_text3.svg'
import cloud from '@/assets/images/fv_cloud.svg'
import circle from '@/assets/images/fv_circle.svg'
import bln1 from '@/assets/images/fv_bln1.svg'
import bln2 from '@/assets/images/fv_bln2.svg'
import star1 from '@/assets/images/fv_star1.svg'
import star2 from '@/assets/images/fv_star2.svg'
import star3 from '@/assets/images/fv_star3.svg'
import triangle from '@/assets/images/fv_triangle.svg'

const letters = [
  { src: require('@/assets/images/letter_1.svg'), alt: '性' },
  { src: require('@/assets/images/letter_2.svg'), alt: '各' },
  { src: require('@/assets/images/letter_3.svg'), alt: '各' },
  { src: require('@/assets/images/letter_4.svg'), alt: '各' },
  { src: require('@/assets/images/letter_5.svg'), alt: '各' },
  { src: require('@/assets/images/letter_6.svg'), alt: '各' },
  { src: require('@/assets/images/letter_7.svg'), alt: '各' },
]
</script>

<template>
  <div class="fv">
    <h1>
      <img
        v-for="(image, index) in letters"
        :key="index"
        :src="image.src"
        width="343"
        height="98"
        :alt="image.alt"
      />
    </h1>
    <div class="fv__main">
      <img
        class="board"
        src="/common/beauty/diagnosis/osaka/fv_board.svg"
        width="343"
        height="253"
        alt=""
      />
      <img
        class="text text1"
        src="/common/beauty/diagnosis/osaka/fv_text1.svg"
        alt="質問に答えて、あなたの"
      />
      <img
        class="text text2"
        src="/common/beauty/diagnosis/osaka/fv_text2.svg"
        alt="性格に合った美容業界の"
      />
      <img
        class="text text3"
        src="/common/beauty/diagnosis/osaka/fv_text3.svg"
        alt="お仕事を見てみよう"
      />
      <img class="cloud" v-lazy="cloud" alt="let's try" />
      <img class="bln circle" v-lazy="circle" alt="" />
      <img class="bln bln1" v-lazy="bln1" alt="" />
      <img class="bln bln2" v-lazy="bln2" alt="" />

      <img class="bln star1" v-lazy="star1" alt="" />
      <img class="bln star2" v-lazy="star2" alt="" />
      <img class="bln star3" v-lazy="star3" alt="" />
      <img class="bln triangle" v-lazy="triangle" alt="" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/inc/_function';
@import '@/assets/scss/inc/_mixin';

@keyframes fadeIn {
  0% {
    transform: translateY(20px) scale(0.5);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.fv {
  --ease: cubic-bezier(0.445, 0.05, 0.55, 0.95);
  position: relative;
  margin-block: 24px 48px;

  h1 {
    position: absolute;
    inset: 6px 0 auto 0;
    z-index: 4;

    img {
      position: absolute;
      inset: 0;
      transform-origin: bottom center;
      transform: translate(0, 20px) scale(0.5);
      opacity: 0;
      animation: fadeIn 0.3s cubic-bezier(0.65, 1.8, 0.5, 0.8) forwards;
      animation-delay: 10s;

      &:nth-child(1) {
        position: relative;
        animation-delay: 1s;
      }
      &:nth-child(2) {
        animation-delay: 1.05s;
      }
      &:nth-child(3) {
        animation-delay: 1.1s;
      }
      &:nth-child(4) {
        animation-delay: 1.15s;
      }
      &:nth-child(5) {
        animation-delay: 1.2s;
      }
      &:nth-child(6) {
        animation-delay: 1.25s;
      }
      &:nth-child(7) {
        animation-delay: 1.3s;
      }
    }
  }

  .is-loaded & {
    h1 {
      img {
        animation-play-state: running;
      }
    }
  }

  &__main {
    position: relative;

    img {
      position: absolute;
      inset: 0;

      &:first-child {
        position: relative;
      }
    }

    .board {
      @keyframes buttons {
        0% {
          scale: 0.1;
          opacity: 0;
        }
        40% {
          scale: 1.285;
          opacity: 0.7;
          visibility: visible;
        }
        90% {
          scale: 0.899;
          opacity: 1;
          visibility: visible;
        }
        100% {
          scale: 1;
          opacity: 1;
          visibility: visible;
        }
      }
      position: relative;
      z-index: 2;
      animation: buttons 0.5s ease-in-out forwards;
    }

    .text {
      opacity: 0;
      visibility: hidden;
      @keyframes text {
        0% {
          translate: -20px 0;
          opacity: 0;
          visibility: hidden;
        }
        100% {
          translate: 0 0;
          opacity: 1;
          visibility: visible;
        }
      }
      z-index: 4;
      animation: text 0.4s ease-in-out forwards;
    }

    .text1 {
      animation-delay: 1.2s;
      z-index: 4;
    }

    .text2 {
      z-index: 4;
      animation-delay: 1.3s;
    }

    .text3 {
      z-index: 4;
      animation-delay: 1.4s;
    }

    .bln {
      position: absolute;
      @keyframes common {
        0% {
          transform: translate3d(0, 0, 0);
        }
        100% {
          transform: translate3d(0, 5%, 0);
        }
      }
      @keyframes small {
        0% {
          transform: translate3d(0, 0, 0);
        }
        100% {
          transform: translate3d(0, 50%, 0);
        }
      }
      @keyframes show {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
    }

    .circle {
      width: 46px;
      inset: -44px 28px auto auto;
      z-index: 6;
      opacity: 0;
      animation: circle 4s infinite alternate, show 1s ease-in-out 2s forwards;
      transform-origin: center;
      @keyframes circle {
        0% {
          rotate: 40deg;
        }
        0% {
          rotate: -60deg;
        }
        100% {
          rotate: 0;
        }
      }
      @include media(sm) {
        width: vw(42);
        inset: vw(-40) vw(28) auto auto;
      }
    }

    .bln1 {
      z-index: 4;
      inset: 0;
      transform-origin: bottom left;
      opacity: 0;
      animation: common 3s var(--ease) infinite alternate,
        show 1s ease-in-out 2.4s forwards;
    }

    .bln2 {
      z-index: 4;
      inset: 0;
      opacity: 0;
      transform-origin: center right;
      animation: common 4s var(--ease) infinite alternate,
        show 1s ease-in-out 2s forwards;
    }

    .cloud {
      z-index: 4;
      opacity: 0;
      animation: cloud 4s linear infinite, slideIn 0.6s ease-in 1.5s forwards;

      @keyframes cloud {
        0% {
          scale: 1;
        }
        5% {
          scale: 1;
        }
        10% {
          scale: 1;
        }
        20% {
          scale: 1.025;
        }
        25% {
          scale: 1;
        }
        30% {
          scale: 1.05;
        }
        50% {
          scale: 1;
        }
        100% {
          scale: 1;
        }
      }
      transform-origin: bottom right;
    }
    @keyframes slideIn {
      0% {
        opacity: 0;
        translate: 10px 0;
      }

      100% {
        opacity: 1;
        translate: 0 0;
      }
    }

    .triangle {
      width: 20px;
      inset: auto auto -32px 72px;
      animation: small 4s var(--ease) infinite alternate;
      @include media(sm) {
        width: vw(20);
        inset: auto auto vw(-32) vw(72);
      }
    }

    .star1 {
      width: 65px;
      inset: -40px auto auto 100px;
      animation: small 3s var(--ease) infinite alternate;
      @include media(sm) {
        width: vw(64);
        inset: vw(-40) auto auto vw(90);
      }
    }

    .star2,
    .star3 {
      width: 78px;
      inset: auto 18px -40px auto;
      animation: star 6s var(--ease) infinite alternate;
      @keyframes star {
        0% {
          transform: translate3d(0, 0, 0);
        }
        100% {
          transform: translate3d(0, 20%, 0);
        }
      }
      @include media(sm) {
        width: vw(72);
        inset: auto vw(16) vw(-40) auto;
      }
    }
  }
}
</style>
